import { format } from "date-fns/format";
import { isValid } from "date-fns/isValid";
import { parse } from "date-fns/parse";
import { parseFormDateString } from "./form-date.js";
function formatItineraryLocationTitle(primaryLocation, secondaryLocation, emptyLabel = 'Where to?') {
    const primaryName = primaryLocation?.itemName;
    const secondaryName = secondaryLocation?.itemName;
    if (primaryName && secondaryName) return `${primaryName} to ${secondaryName}`;
    return primaryName || secondaryName || emptyLabel;
}
function formatItineraryDateRange(startDate, endDate, referenceDate = new Date()) {
    const from = parseFormDateString(startDate, referenceDate);
    if (!from) return;
    const to = parseFormDateString(endDate, referenceDate);
    if (!to || to.getTime() === from.getTime()) return format(from, 'EEE, MMM d');
    return `${format(from, 'EEE, MMM d')} - ${format(to, 'EEE, MMM d')}`;
}
function formatItineraryTime(time, referenceDate) {
    if (!time) return;
    const parsed = parse(time, 'HH:mm', referenceDate);
    if (!isValid(parsed)) return;
    return format(parsed, 'h:mm a').replace(':00', '').replace(/\b(am|pm)\b/i, (match)=>'am' === match.toLowerCase() ? 'ᴀᴍ' : 'ᴘᴍ');
}
function formatItineraryDateTimeRange(startDate, endDate, startTime, endTime, referenceDate = new Date()) {
    const from = parseFormDateString(startDate, referenceDate);
    if (!from) return;
    const formatDateTime = (date, time)=>{
        const formattedDate = format(date, 'MMM d');
        const formattedTime = formatItineraryTime(time, referenceDate);
        return formattedTime ? `${formattedDate}, ${formattedTime}` : formattedDate;
    };
    const start = formatDateTime(from, startTime);
    const to = parseFormDateString(endDate, referenceDate);
    if (!to) return start;
    return `${start} – ${formatDateTime(to, endTime)}`;
}
function formatItineraryTravelers(travelers, { roomsEnabled = false } = {}) {
    if (!travelers) return;
    const travelerCount = travelers.adults + travelers.children + travelers.lapInfants;
    if (!travelerCount) return;
    const parts = [
        `${travelerCount} traveler${1 === travelerCount ? '' : 's'}`
    ];
    if (roomsEnabled && travelers.rooms) parts.push(`${travelers.rooms} room${1 === travelers.rooms ? '' : 's'}`);
    return parts.join(', ');
}
export { formatItineraryDateRange, formatItineraryDateTimeRange, formatItineraryLocationTitle, formatItineraryTravelers };
